module.exports = __webpack_public_path__ + "static/media/onoake-extra-1.b6449584.png";